import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import BrandingRadioGroup from 'Components/molecules/BrandingRadioGroup';
import BreadCrumbs from 'Components/molecules/Breadcrumbs';
import DropZone from 'Components/molecules/DropZone';
import FieldGroup from 'Components/molecules/FieldGroup';
import FormControls from './FormControls';
import InputField from 'Components/molecules/InputField';
import React, { useEffect } from 'react';
import Section from 'Components/molecules/Section';
import SiteNavigation from 'Components/molecules/SiteNavigation';
import SwitchField from 'Components/molecules/SwitchField';
import Wysiwig from 'Components/molecules/Wysiwig';
import { Box, Divider, Grid, Text } from 'theme-ui';
import { Inline } from '@bedrock-layout/inline';
import { Split } from '@bedrock-layout/split';
import { Stack } from '@bedrock-layout/stack';
import GoToTop from 'Components/molecules/GoToTop';
import { withFeatureFlagDefaults } from 'Constants/featureFlags';
import { TENANT_FORM_FIELDS } from 'Constants/tenantFormFields';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation, useParams } from 'react-router';
import useTenant from 'Hooks/useTenant';
import useUpdateTenant from 'Hooks/useUpdateTenant';
import useUpdateTenantImage from 'Hooks/useUpdateTenantImage';
import TENANT_INITIAL_STATE from 'Constants/tenantFormInitialState';
import { yupResolver } from '@hookform/resolvers/yup';
import TENANT_FORM_SCHEMA from 'Constants/schemas/tenantFormSchema';
import Loader from 'Components/molecules/Loader';
import Tooltip from 'Components/molecules/Tooltip';
import RadioField from 'Components/molecules/RadioField';
import KeyValueFieldArray from 'Components/molecules/KeyValueFieldArray';
import { codeFlagsToFieldArray } from 'Utils/codeFlags';

function TenantView() {
  const updateTenant = useUpdateTenant();
  const updateImage = useUpdateTenantImage();
  const location = useLocation();
  const params = useParams();
  const { isLoading, data } = useTenant(params);

  const methods = useForm({
    mode: 'onSubmit',
    defaultValues: TENANT_INITIAL_STATE,
    resolver: yupResolver(TENANT_FORM_SCHEMA),
  });

  useEffect(() => {
    // you can use `async` server requests to populate your form!
    if (data && isLoading === false) {
      methods.reset({ ...withFeatureFlagDefaults(data), codeFlags: codeFlagsToFieldArray(data.codeFlags) });
    }
    return methods.reset();
  }, [params.id, methods.reset, data, isLoading]);
  //
  // const onClear = () => {}
  const onSubmit = async () => {
    alert('submit');
    const fields = await methods.getValues();
    let result = _.omit(fields, ['homePageConfiguration.logoFormat']);
    updateTenant.mutate(result, {
      onSuccess: () => {
        if (Array.isArray(fields.homePageConfiguration.logoFormat)) {
          updateImage.mutate(fields, {
            onError: (err) => alert('Saved Tenant ERROR saving iamge'),
            onSuccess: (d) => alert('Saved Tenant config and Image'),
          });
        }
      },
    });
    // methods.handleSubmit()
  };
  const onUpdateImage = () => {
    alert('updateImage');
  };
  const onCancel = () => {
    alert('cancel');
  };
  const onUpdate = () => {
    alert('update');
  };
  const onClear = () => {
    alert('clear');
  };
  const { SYSTEM, HOMEPAGE_CONFIG, PAGE_CONTENT, FUNDS, READER_CONFIG, FEATURES, LEGAL, BANNER, CODE_FLAGS } =
    TENANT_FORM_FIELDS;

  if (isLoading) return <Loader isActive={true} />;

  return (
    <FormProvider
      {...methods}
      onSave={methods.handleSubmit(onSubmit)}
      onCancel={onCancel}
      onClear={onClear}
      onUpdateImage={methods.handleSubmit(onUpdateImage)}
      onUpdate={methods.handleSubmit(onUpdate)}
      onPublish={methods.handleSubmit(onSubmit)}
      onSubmit={methods.handleSubmit(onSubmit)}
    >
      <Grid variant="layout" bg="muted">
        <GoToTop />
        <Grid variant="layout.header" bg="background" gap={0}>
          <SiteNavigation />
          <Divider variant="layout.header.divider" color="lightgray" />
          <BreadCrumbs />
          <FormControls />
        </Grid>
        <Box variant="layout.body" bg="background" pt="4" pb="6" px="5">
          <Stack gutter="lgXl">
            <Section>
              <Text variant="section">
                {SYSTEM.TITLE}
                <Tooltip />
              </Text>
              <Split gutter="md" fraction="2/3">
                <FieldGroup>
                  {SYSTEM.FIELDS.map((field) => (
                    <InputField key={field.name} variant="input.disabled" disabled {...field} />
                  ))}
                </FieldGroup>
              </Split>
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {HOMEPAGE_CONFIG.TITLE}
                <Tooltip />
              </Text>
              <Split gutter="md" fraction="2/3">
                <FieldGroup>
                  {/*<DropZone name="logo" disabled />*/}
                  {/*<BrandingRadioGroup disabled />*/}
                  {HOMEPAGE_CONFIG.FIELDS.map((field) => {
                    switch (field.component) {
                      case 'dropZone':
                        return <DropZone key={field.name} {...field} variant="input.disabled" disabled />;
                      case 'brandingField':
                        return <BrandingRadioGroup key={field.name} {...field} variant="input.disabled" disabled />;
                      default:
                        return <InputField key={field.name} {...field} variant="input.disabled" disabled />;
                    }
                  })}
                </FieldGroup>
              </Split>
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {PAGE_CONTENT.TITLE}
                <Tooltip />
              </Text>
              <FieldGroup>
                {PAGE_CONTENT.FIELDS.map((field) => (
                  <Wysiwig key={field.name} disabled {...field} />
                ))}
              </FieldGroup>
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {READER_CONFIG.TITLE}
                <Tooltip />
              </Text>
              <Split gutter="md" fraction="2/3">
                <Stack gutter="lg">
                  {READER_CONFIG.FIELDS.map((field) => {
                    switch (field.component) {
                      case 'switchField':
                        return (
                          <Inline key={field.name} gutter="md" stretch="start">
                            <SwitchField
                              label="Diverse Ethnicity"
                              name="readerConfiguration.diverseEthnicity"
                              disabled
                            />
                          </Inline>
                        );
                      default:
                        return <InputField key={field.name} variant="input.disabled" disabled {...field} />;
                    }
                  })}
                </Stack>
              </Split>
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {FEATURES.TITLE}
                <Tooltip />
              </Text>
              <Split gutter="md" fraction="2/3">
                <FieldGroup>
                  <Stack gutter="xl">
                    {FEATURES.FIELDS.map((field) => (
                      <Inline key={field.name} gutter="md" stretch="start">
                        <SwitchField {...field} disabled />
                      </Inline>
                    ))}
                  </Stack>
                </FieldGroup>
              </Split>
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {FUNDS.TITLE}
                <Tooltip text="Coming soon" />
              </Text>
              {FUNDS.FIELDS.map((field, index) => (
                <RadioField key={field.name + index} {...field} disabled />
              ))}
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {LEGAL.TITLE}
                <Tooltip />
              </Text>
              <FieldGroup>
                {LEGAL.FIELDS.map((field) => {
                  switch (field.component) {
                    case 'wysiwigField':
                      return <Wysiwig key={field.name} {...field} disabled />;
                    case 'inputField':
                      return <InputField variant="input.disabled" key={field.name} {...field} disabled />;
                    default:
                      return null;
                  }
                })}
              </FieldGroup>
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {BANNER.TITLE}
                <Tooltip />
              </Text>
              <FieldGroup>
                {BANNER.FIELDS.map((field) => {
                  switch (field.component) {
                    case 'switchField':
                      return (
                        <Inline key={field.name} gutter="md" stretch="start">
                          <SwitchField {...field} disabled />
                        </Inline>
                      );
                    case 'inputField':
                      return <InputField variant="input.disabled" key={field.name} {...field} disabled />;
                    default:
                      return null;
                  }
                })}
              </FieldGroup>
            </Section>
            <Divider color="divider" />
            <Section>
              <Text variant="section">
                {CODE_FLAGS.TITLE}
                <Tooltip text={CODE_FLAGS.TOOLTIP_TEXT} />
              </Text>
              <Split gutter="md" fraction="2/3">
                <FieldGroup>
                  <KeyValueFieldArray name="codeFlags" disabled />
                </FieldGroup>
              </Split>
            </Section>
          </Stack>
        </Box>
      </Grid>
    </FormProvider>
  );
}
export default TenantView;
